module.exports = __webpack_public_path__ + "img/app_img3_1.3377b719.png";